/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ColumnChartProps } from '../../ColumnChart.props';

export const getColumnChartSeriesData = (options: ColumnChartProps): Highcharts.Options => {
  const { plottingData } = options;
  const seriesData: Array<Highcharts.SeriesOptionsType> = plottingData.map((plotData) => {
    return {
      color: plotData.color,
      data: plotData.data,
      name: plotData.name,
      type: 'column',
    };
  });

  return {
    series: seriesData,
  };
};
